import { logger } from "@starlight-core/core/lib";
import { $customerIo } from "@stores/customerio";
import { $datadog, $logger } from "@stores/datadog";
import { $posthog } from "@stores/posthog";

export const $sendEvent = (
  name: string,
  additionalProperties?: Record<string, unknown>,
) => {
  if (!window) {
    logger.error("These functions should only be called in the browser");
    return;
  }
  logger?.info(`Sending event ${name}`, { additionalProperties });
  $datadog.get()?.addAction(name, additionalProperties);
  $customerIo.get()?.track(name, additionalProperties);
  $posthog.get()?.capture(name, additionalProperties);
};

export const $identify = (
  id: string,
  additionalProperties?: {
    email?: string;
    phone?: string;
    name?: string;
    [x: string]: string | undefined;
  },
) => {
  if (!window) {
    logger.error("These functions should only be called in the browser");
    return;
  }
  $datadog.get().setUser({
    id,
    cognito_id: id,
    env: import.meta.env.PUBLIC_SST_STAGE,
    ...additionalProperties,
  });
  $logger.get().setUser({
    id,
    cognito_id: id,
    env: import.meta.env.PUBLIC_SST_STAGE,
    ...additionalProperties,
  });
  $customerIo.get()?.identify(id, {
    env: import.meta.env.PUBLIC_SST_STAGE,
    ...additionalProperties,
  });
  window.$chatwoot.setUser(id, {
    phone_number: additionalProperties?.phone,
    email: additionalProperties?.email,
    name: additionalProperties?.name || "unknown",
  });
  window.$chatwoot.setCustomAttributes({
    cognito_id: id,
  });
  window.delightedSurveys.setPersonProperties({
    email: additionalProperties?.email,
  });
  $posthog.get()?.identify(id, {
    env: import.meta.env.PUBLIC_SST_STAGE,
    ...additionalProperties,
  });
  logger.info("Identified user", { id });
};
